export default {
    card: {
        title: 'Backups',
        intro: "A backup bundles this website's database rows and media files. Daily backups run automatically; use the button for an on-demand snapshot.",
        create: 'Create backup',
        empty: 'No backups yet.',
        columns: {
            kind: 'Kind',
            size: 'Size',
        },
        confirmDelete: 'Delete?',
        restore: 'Restore',
        deleteBackup: 'Delete backup',
    },
    kind: {
        manual: 'manual',
        scheduled: 'scheduled',
        preRestore: 'pre-restore',
        imported: 'imported',
        final: 'final',
    },
    lastRestore: {
        title: 'Last restore',
        detail: 'of the backup from {from}, started {when} by {who}',
        goneBackup: 'a backup no longer listed',
    },
    status: {
        queued: 'queued',
        running: 'running',
        success: 'success',
        failed: 'failed',
    },
    restoreDialog: {
        title: 'Restore this backup?',
        body: "This replaces the website's {current} with the contents of the backup from {age}. Current data is overwritten. A {safety} first, so this can be undone.",
        current: 'current database rows and media files',
        safety: 'safety backup is taken automatically',
    },
};
